import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import CardName from "../../../components/global/CardName";
import axios from 'axios';
import ButtonAction from '../../../components/global/ButtonAction';
import SrvButton from "../../../components/global/SrvButton";

function ModalApi({ show, onHide, model, removeHandler }) {

    const [log, setLog] = useState(null);
    const [loadingToken, setLoadingToken] = useState(false);
    const [formToken, setFormToken] = useState(null);


    function showTokenHundler() {
        setLog(null);
        setLoadingToken(true);
        axios.get('/api_main/company/userServiceApiTokenGet', { params: { ID_Company: model.ID_Company, ID_Service: process.env.REACT_APP_ID_SERVICE } })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormToken(res.data.Data);
                }
                else {
                    setLog(res.data.Error);
                }
                setLoadingToken(false);
            })
            .catch(() => {
                setLoadingToken(false);
                setLog('Неизвестная ошибка!');
            })
    }

    const [modalRemoveShow, setModalRemoveShow] = useState(false);
    const [loadingRemove, setLoadingRemove] = useState(false);
    const [logRemove, setLogRemove] = useState(null);

    function remove() {
        setLoadingRemove(true);
        removeHandler(model.ID_Company);
    }


    return (
        <>
            {modalRemoveShow === true && (
                <Modal show={modalRemoveShow} onHide={() => setModalRemoveShow(false)}>
                    <Modal.Body>
                        <div className="modal_close" onClick={() => setModalRemoveShow(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-20">Удаление ключа</div>
                        <div className="text-center mb-20">Подтвердите удаление ключа
                            <br></br>
                            <div className="badge" style={{ backgroundColor: model.Color, marginTop: "6px" }}>{model.Name}</div>
                        </div>
                        {logRemove !== null && <div className="form_error text-center mt-15">{logRemove}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="remove" loading={loadingRemove} size={'lg'} onClick={() => remove()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}


            <Modal show={show} onHide={onHide} size="lg">
                <Modal.Body className='modal_min_height_350'>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="row mb-15" >
                        <div className="col-md-7">
                            <div className="mb-3">
                                <CardName name={model.Name_Company} onlyRead={true} placeholder='Название источника...' />
                            </div>

                            <div className="mb-3">
                                <div>Токен API:</div>
                                <div><code>{formToken === null ? '********************' : formToken}</code></div>
                                {formToken === null && (<div onClick={() => showTokenHundler()}><code style={{ cursor: 'pointer' }} >показать токен</code></div>)}
                                {loadingToken === true && (<div className="loader_01"></div>)}
                            </div>

                        </div>
                        <div className="col-md-5">
                            <div className="card-block-title">Действия</div>
                            <ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} />
                        </div>
                    </div>
                    {log != null && (
                        <div className="form_error text-center">
                            {log}
                        </div>
                    )}
                </Modal.Body>
            </Modal >
        </>
    );
}

export default ModalApi;